/* eslint-disable import/no-duplicates */
import { isValid, parse } from 'date-fns';
import i18n from '@app/i18n';
import { formatDateLocales } from '.';

const currentLocale = i18n.language || 'en';
const locale: Locale = formatDateLocales[currentLocale];

const FORMAT = 'dd.MM.yyyy';

export const parsedDateString = (day: number, month: number, year: number) => {
  const dayString = day.toString().padStart(2, '0');
  const monthString = month.toString().padStart(2, '0');
  const yearString = year.toString();

  const parsed = parse(`${dayString}.${monthString}.${yearString}`, FORMAT, new Date(), {
    locale,
  });
  return parsed;
};

export const isValidDate = (day: number, month: number, year: number) => {
  const parsed = parsedDateString(day, month, year);

  return isValid(parsed);
};
